import { render, staticRenderFns } from "./CommissionDetailsReport.vue?vue&type=template&id=57ad96e2"
import script from "./CommissionDetailsReport.vue?vue&type=script&lang=js"
export * from "./CommissionDetailsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports